module.exports = __webpack_public_path__ + "e94d0311ec09f4c5512fa74773292fbe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/zombie-bolts-s.png
// module id = 2966
// module chunks = 0